import { jdGreen } from '../../themes';
export const fuelAlertVariants = ['info', 'success', 'warning', 'error'];
const capitalize = (value) => `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
const getColorKey = (variant, shade) => `FuelColorAlert${capitalize(variant)}${capitalize(shade)}`;
export const getAlertColor = (tokens = jdGreen.tokens, alertVariant = 'info', alertShade = 'background') => {
    const variant = alertVariant;
    const shade = alertShade;
    const colorKey = getColorKey(variant, shade);
    return tokens[colorKey];
};
